var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.body",
          value: _vm.loading,
          expression: "loading",
          modifiers: { body: true }
        }
      ]
    },
    [
      _c(
        "div",
        { staticClass: "c_page-title" },
        [
          _c("div", [_vm._v("代采订单报表详情")]),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "icon-fresh",
              attrs: { size: "mini", icon: "el-icon-refresh" },
              on: {
                click: function($event) {
                  return _vm.fetchData(true)
                }
              }
            },
            [_vm._v("刷新")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.resData
        ? _c(
            "div",
            {
              staticClass: "c_page-title",
              staticStyle: { "padding-bottom": "0", height: "40px" }
            },
            _vm._l([_vm.resData.supply], function(item) {
              return _c(
                "ul",
                {
                  staticClass: "list-header",
                  staticStyle: { "list-style": "none", "font-size": "14px" }
                },
                [
                  _c("li", [_vm._v("商家ID：" + _vm._s(item.supply_id))]),
                  _vm._v(" "),
                  _c("li", [_vm._v("商家名称：" + _vm._s(item.supply_name))]),
                  _vm._v(" "),
                  _c("li", [_vm._v("代采订单：" + _vm._s(item.woid))]),
                  _vm._v(" "),
                  _c("li", [_vm._v("代采时间：" + _vm._s(item.create_time))]),
                  _vm._v(" "),
                  _c("li", [_vm._v("市场：" + _vm._s(item.market_name))])
                ]
              )
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "c_page-title",
          staticStyle: { "padding-bottom": "0", height: "80px" }
        },
        [
          _vm.resData
            ? _c(
                "el-row",
                {
                  staticClass: "row",
                  attrs: {
                    gutter: 20,
                    type: "flex",
                    align: "middle",
                    justify: "space-around"
                  }
                },
                _vm._l(_vm.resData.order, function(item) {
                  return _c(
                    "el-col",
                    {
                      key: item.key,
                      staticClass: "column",
                      attrs: { span: 24 / _vm.resData.order.length }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "status",
                          class: { active: _vm.type === item.key },
                          staticStyle: {
                            height: "60px",
                            "font-size": "14px",
                            width: "120px"
                          },
                          on: {
                            click: function($event) {
                              return _vm.selectStatus(item.key)
                            }
                          }
                        },
                        [
                          _c("div", [_vm._v(_vm._s(item.label))]),
                          _vm._v(" "),
                          _c("div", [
                            _vm._v(
                              _vm._s(item.num) + " / " + _vm._s(item.amount)
                            )
                          ])
                        ]
                      )
                    ]
                  )
                }),
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c(
            "div",
            {
              staticStyle: {
                "margin-top": "30px",
                "padding-bottom": "15px",
                height: "35px"
              }
            },
            [
              _c(
                "el-col",
                { staticStyle: { "margin-right": "20px" }, attrs: { span: 2 } },
                [
                  _c("el-input", {
                    attrs: { size: "small", placeholder: "款号" },
                    nativeOn: {
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.search.apply(null, arguments)
                      }
                    },
                    model: {
                      value: _vm.form.goods_kh,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "goods_kh", $$v)
                      },
                      expression: "form.goods_kh"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { staticStyle: { "margin-right": "20px" }, attrs: { span: 2 } },
                [
                  _c("el-input", {
                    attrs: { size: "small", placeholder: "货号" },
                    nativeOn: {
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.search.apply(null, arguments)
                      }
                    },
                    model: {
                      value: _vm.form.goods_no,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "goods_no", $$v)
                      },
                      expression: "form.goods_no"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { staticStyle: { "margin-right": "40px" }, attrs: { span: 2 } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small", type: "primary" },
                      on: { click: _vm.search }
                    },
                    [_vm._v("\n          查询")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("el-col", { staticStyle: { border: "1px solid #ddd" } }, [
            _vm.resData
              ? _c(
                  "div",
                  { staticStyle: { "margin-bottom": "0" } },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          background: "#f3f3f3",
                          height: "50px",
                          "line-height": "30px",
                          padding: "0 25px",
                          display: "flex",
                          "align-items": "center",
                          position: "relative"
                        }
                      },
                      [
                        _c("div", [
                          _vm._v(
                            "\n            数据统计: 共" +
                              _vm._s(_vm.resData.collect.num) +
                              "件，计" +
                              _vm._s(_vm.resData.collect.amount) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticStyle: { position: "absolute", right: "0" } },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { size: "small", type: "success" },
                                on: { click: _vm.output }
                              },
                              [_vm._v("\n              导出")]
                            )
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _vm.type == 1
                      ? _c(
                          "el-table",
                          {
                            directives: [
                              {
                                name: "loading",
                                rawName: "v-loading",
                                value: _vm.tableLoading,
                                expression: "tableLoading"
                              }
                            ],
                            ref: "multipleTable",
                            staticStyle: { width: "100%" },
                            attrs: {
                              height: "800",
                              data: _vm.resData.list,
                              "tooltip-effect": "dark"
                            }
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                prop: "goods_kh",
                                label: "款号",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "goods_no",
                                label: "货号",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "goods_name",
                                label: "商品名称",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "brand_name",
                                label: "品牌",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "img",
                                label: "图片",
                                align: "center"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              width: "70px",
                                              height: "85px",
                                              overflow: "hidden"
                                            }
                                          },
                                          [
                                            _c(
                                              "viewer",
                                              {
                                                staticClass: "viewer",
                                                attrs: {
                                                  images: scope.row.imgs
                                                }
                                              },
                                              _vm._l(scope.row.imgs, function(
                                                src
                                              ) {
                                                return _c("img", {
                                                  key: src,
                                                  staticStyle: {
                                                    width: "70px",
                                                    height: "85px"
                                                  },
                                                  attrs: { src: src }
                                                })
                                              }),
                                              0
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                2005739993
                              )
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "co_val",
                                label: "颜色",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "si_val",
                                label: "尺码",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "price",
                                label: "代采单价",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "num",
                                label: "代采数量",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "create_time",
                                label: "开单时间",
                                align: "center"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.type == 2
                      ? _c(
                          "el-table",
                          {
                            directives: [
                              {
                                name: "loading",
                                rawName: "v-loading",
                                value: _vm.tableLoading,
                                expression: "tableLoading"
                              }
                            ],
                            ref: "multipleTable",
                            staticStyle: { width: "100%" },
                            attrs: {
                              height: "800",
                              data: _vm.resData.list,
                              "tooltip-effect": "dark"
                            }
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                prop: "goods_kh",
                                label: "款号",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "goods_no",
                                label: "货号",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "goods_name",
                                label: "商品名称",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "brand_name",
                                label: "品牌",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "img",
                                label: "图片",
                                align: "center"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              width: "70px",
                                              height: "85px",
                                              overflow: "hidden"
                                            }
                                          },
                                          [
                                            _c(
                                              "viewer",
                                              {
                                                staticClass: "viewer",
                                                attrs: {
                                                  images: scope.row.imgs
                                                }
                                              },
                                              _vm._l(scope.row.imgs, function(
                                                src
                                              ) {
                                                return _c("img", {
                                                  key: src,
                                                  staticStyle: {
                                                    width: "70px",
                                                    height: "85px"
                                                  },
                                                  attrs: { src: src }
                                                })
                                              }),
                                              0
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                2005739993
                              )
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "co_val",
                                label: "颜色",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "si_val",
                                label: "尺码",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "price",
                                label: "代采单价",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "num",
                                label: "入库数量",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "stock_in_record_where",
                                label: "库区",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "stock_in_record_status",
                                label: "状态",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "admin_name",
                                label: "入库人",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "create_time",
                                label: "入库时间",
                                align: "center"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.type == 3 || _vm.type == 4
                      ? _c(
                          "el-table",
                          {
                            directives: [
                              {
                                name: "loading",
                                rawName: "v-loading",
                                value: _vm.tableLoading,
                                expression: "tableLoading"
                              }
                            ],
                            ref: "multipleTable",
                            staticStyle: { width: "100%" },
                            attrs: {
                              height: "800",
                              data: _vm.resData.list,
                              "tooltip-effect": "dark"
                            }
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                prop: "goods_kh",
                                label: "款号",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "goods_no",
                                label: "货号",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "goods_name",
                                label: "商品名称",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "brand_name",
                                label: "品牌",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "img",
                                label: "图片",
                                align: "center"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              width: "70px",
                                              height: "85px",
                                              overflow: "hidden"
                                            }
                                          },
                                          [
                                            _c(
                                              "viewer",
                                              {
                                                staticClass: "viewer",
                                                attrs: {
                                                  images: scope.row.imgs
                                                }
                                              },
                                              _vm._l(scope.row.imgs, function(
                                                src
                                              ) {
                                                return _c("img", {
                                                  key: src,
                                                  staticStyle: {
                                                    width: "70px",
                                                    height: "85px"
                                                  },
                                                  attrs: { src: src }
                                                })
                                              }),
                                              0
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                2005739993
                              )
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "co_val",
                                label: "颜色",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "si_val",
                                label: "尺码",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "price",
                                label: "代采单价",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "num",
                                label: "欠货数量",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "create_time",
                                label: "生成时间",
                                align: "center"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.type == 5
                      ? _c(
                          "el-table",
                          {
                            directives: [
                              {
                                name: "loading",
                                rawName: "v-loading",
                                value: _vm.tableLoading,
                                expression: "tableLoading"
                              }
                            ],
                            ref: "multipleTable",
                            staticStyle: { width: "100%" },
                            attrs: {
                              height: "800",
                              data: _vm.resData.list,
                              "tooltip-effect": "dark"
                            }
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                prop: "goods_kh",
                                label: "款号",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "goods_no",
                                label: "货号",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "goods_name",
                                label: "商品名称",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "brand_name",
                                label: "品牌",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "img",
                                label: "图片",
                                align: "center"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              width: "70px",
                                              height: "85px",
                                              overflow: "hidden"
                                            }
                                          },
                                          [
                                            _c(
                                              "viewer",
                                              {
                                                staticClass: "viewer",
                                                attrs: {
                                                  images: scope.row.imgs
                                                }
                                              },
                                              _vm._l(scope.row.imgs, function(
                                                src
                                              ) {
                                                return _c("img", {
                                                  key: src,
                                                  staticStyle: {
                                                    width: "70px",
                                                    height: "85px"
                                                  },
                                                  attrs: { src: src }
                                                })
                                              }),
                                              0
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                2005739993
                              )
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "co_val",
                                label: "颜色",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "si_val",
                                label: "尺码",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "price",
                                label: "代采单价",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "num",
                                label: "代采数量",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "wcg_ded_status",
                                label: "抵扣状态",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "ded_price",
                                label: "抵扣金额",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "admin_name",
                                label: "操作人",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "create_time",
                                label: "操作时间",
                                align: "center"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.type == 6
                      ? _c(
                          "el-table",
                          {
                            directives: [
                              {
                                name: "loading",
                                rawName: "v-loading",
                                value: _vm.tableLoading,
                                expression: "tableLoading"
                              }
                            ],
                            ref: "multipleTable",
                            staticStyle: { width: "100%" },
                            attrs: {
                              height: "800",
                              data: _vm.resData.list,
                              "tooltip-effect": "dark"
                            }
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                prop: "goods_kh",
                                label: "款号",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "goods_no",
                                label: "货号",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "goods_name",
                                label: "商品名称",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "brand_name",
                                label: "品牌",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "img",
                                label: "图片",
                                align: "center"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              width: "70px",
                                              height: "85px",
                                              overflow: "hidden"
                                            }
                                          },
                                          [
                                            _c(
                                              "viewer",
                                              {
                                                staticClass: "viewer",
                                                attrs: {
                                                  images: scope.row.imgs
                                                }
                                              },
                                              _vm._l(scope.row.imgs, function(
                                                src
                                              ) {
                                                return _c("img", {
                                                  key: src,
                                                  staticStyle: {
                                                    width: "70px",
                                                    height: "85px"
                                                  },
                                                  attrs: { src: src }
                                                })
                                              }),
                                              0
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                2005739993
                              )
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "co_val",
                                label: "颜色",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "si_val",
                                label: "尺码",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "price",
                                label: "代采单价",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "num",
                                label: "代采数量",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "wcg_refund_status",
                                label: "状态",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "admin_name",
                                label: "操作人",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "create_time",
                                label: "操作时间",
                                align: "center"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.type == 7
                      ? _c(
                          "el-table",
                          {
                            directives: [
                              {
                                name: "loading",
                                rawName: "v-loading",
                                value: _vm.tableLoading,
                                expression: "tableLoading"
                              }
                            ],
                            ref: "multipleTable",
                            staticStyle: { width: "100%" },
                            attrs: {
                              height: "800",
                              data: _vm.resData.list,
                              "tooltip-effect": "dark"
                            }
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                prop: "goods_kh",
                                label: "款号",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "goods_no",
                                label: "货号",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "goods_name",
                                label: "商品名称",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "brand_name",
                                label: "品牌",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "img",
                                label: "图片",
                                align: "center"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              width: "70px",
                                              height: "85px",
                                              overflow: "hidden"
                                            }
                                          },
                                          [
                                            _c(
                                              "viewer",
                                              {
                                                staticClass: "viewer",
                                                attrs: {
                                                  images: scope.row.imgs
                                                }
                                              },
                                              _vm._l(scope.row.imgs, function(
                                                src
                                              ) {
                                                return _c("img", {
                                                  key: src,
                                                  staticStyle: {
                                                    width: "70px",
                                                    height: "85px"
                                                  },
                                                  attrs: { src: src }
                                                })
                                              }),
                                              0
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                2005739993
                              )
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "co_val",
                                label: "颜色",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "si_val",
                                label: "尺码",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "price",
                                label: "代采单价",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "num",
                                label: "结束数量",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "create_time",
                                label: "操作时间",
                                align: "center"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.type == 8
                      ? _c(
                          "el-table",
                          {
                            directives: [
                              {
                                name: "loading",
                                rawName: "v-loading",
                                value: _vm.tableLoading,
                                expression: "tableLoading"
                              }
                            ],
                            key: "tab3",
                            ref: "multipleTable",
                            staticStyle: { width: "100%" },
                            attrs: {
                              height: "800",
                              data: _vm.resData.list,
                              "tooltip-effect": "dark"
                            }
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                prop: "bill_id",
                                label: "账单号",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "create_time",
                                label: "账单日期",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "goods_kh",
                                label: "款号",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "goods_no",
                                label: "货号",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "goods_name",
                                label: "商品名称",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "brand_name",
                                label: "品牌",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "img",
                                label: "图片",
                                align: "center"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              width: "70px",
                                              height: "85px",
                                              overflow: "hidden"
                                            }
                                          },
                                          [
                                            _c(
                                              "viewer",
                                              {
                                                staticClass: "viewer",
                                                attrs: {
                                                  images: scope.row.imgs
                                                }
                                              },
                                              _vm._l(scope.row.imgs, function(
                                                src
                                              ) {
                                                return _c("img", {
                                                  key: src,
                                                  staticStyle: {
                                                    width: "70px",
                                                    height: "85px"
                                                  },
                                                  attrs: { src: src }
                                                })
                                              }),
                                              0
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                2005739993
                              )
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "co_val",
                                label: "颜色",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "si_val",
                                label: "尺码",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "price",
                                label: "代采单价",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "num",
                                label: "结账数量",
                                align: "center"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e()
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8cf5122c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8cf5122c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/supplybill/ReportDetail.vue
// module id = null
// module chunks = 